import { createSelector } from '@ngrx/store';

import { ForceState } from './state';

const selectFeatureState = (s) => s.forces as ForceState;

export const selectForces = createSelector(selectFeatureState, (s) => s.forces);
